import BaseRequestLoadPageMixin from "@/modules/core/request/protected/BaseRequestLoadPageMixin";
import editor from "./MicroCreditRequestEditor";
import service from "./MicroCreditRequestService";

export default {
  mixins: [BaseRequestLoadPageMixin],

  components: {
    editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.title;
    }
  }
};
